import React from "react";
import "./Servicehero.css";

export default function Servicehero({
  bgImage = "/hero.jpg",
  title = "Our Services",
  breadcrumbLeft = "Home",
  breadcrumbRight = "Our Services",
}) {
  return (
    <section
      className="service-hero"
      style={{ backgroundImage: `url(${bgImage})` }}
      aria-label="Service hero banner"
    >
      {/* Dark overlay with new colors */}
      <div className="service-hero__overlay" aria-hidden="true" />

      <div className="service-hero__inner">
        <h1 className="service-hero__title">{title}</h1>

        <div className="service-hero__crumbs" aria-label="Breadcrumb">
          <span className="service-hero__crumb">{breadcrumbLeft}</span>
          <span className="service-hero__sep" aria-hidden="true">
            /
          </span>
          <span className="service-hero__crumb service-hero__crumb--active">
            {breadcrumbRight}
          </span>
        </div>
      </div>
    </section>
  );
}